<template>
    <v-container class="report-body ma-0 pb-4">
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="12" md="4">
                        Relatório de Hóspedes
                    </v-col>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="4" class="text-right">
                        <v-tooltip bottom color="primary">
                            <template v-slot:activator="{ on }" >
                                <v-btn
                                    v-on="on"
                                    color="white"
                                    :loading="awaitingReportDownload"
                                    @click="exportReport()"
                                >
                                    <v-icon color="primary">mdi-download</v-icon>
                                </v-btn>
                            </template>
                            Baixar Relatório em XLS
                        </v-tooltip>
                        <v-btn
                            width="50%"
                            color="#f2c037"
                            class="filter-btn"
                            @click="filterDrawer = !filterDrawer"
                        >
                            <v-icon class="mr-2" small>mdi-filter-outline</v-icon>
                            Filtros {{filteredResult ? '(ativo)' : ''}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <guest-report-table
                    ref="guestReportTable"
                />
            </v-card-text>
        </v-card>
        <filter-drawer
            :show-drawer="filterDrawer"
            @clear-filter="clearFilter()"
            @apply-filter="applyFilter()"
        >
            <template v-slot:form>
                <v-form @submit.prevent="applyFilter()">
                    <v-row>
                        <v-col cols="12" md="12">
                            <p class="mb-2 filter-label">Hóspede</p>
                            <v-text-field
                                v-model="filterGuestName"
                                outlined
                                hide-details
                                append-icon="mdi-account"
                            />
                        </v-col>
                    </v-row>
                    <p class="mt-6 mb-2 filter-label">Reservas Feitas Em</p>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-menu
                                :close-on-content-click="true"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="filterCreatedStartDate"
                                        label="De"
                                        append-icon="mdi-calendar"
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="createdStartDateCalendar"
                                    no-title
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-menu
                                :close-on-content-click="true"
                                transition="scale-transition"
                                offset-y
                                left
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="filterCreatedUntilDate"
                                        label="Até"
                                        append-icon="mdi-calendar"
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="createdUntilDateCalendar"
                                    no-title
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </filter-drawer>
    </v-container>
</template>

<script>
import FilterDrawer from "../../components/Reports/FilterDrawer.vue";
import GuestReportTable from "../../components/Reports/Tables/GuestReportTable.vue";
import {downloadFile, getFileNameWithSalt} from "../../services/DownloadFileService";

export default {
    name: "GuestsReport",

    components: {
        GuestReportTable,
        FilterDrawer,
    },

    data: () => ({
        filterDrawer: '',
        filterGuestName: '',
        filterCreatedStartDate: '',
        filterCreatedUntilDate: '',
        createdStartDateCalendar: '',
        createdUntilDateCalendar: '',
        filteredResult: '',
        filter: {},
        awaitingReportDownload: false,
    }),

    methods: {
        formatDate (dateCalendar) {
            if (!dateCalendar) return null

            const [year, month, day] = dateCalendar.split('-')
            return `${day}/${month}/${year}`
        },

        formatDateToFilter(date) {
            let formattedDate = '';
            if (date) {
                let dateSplit = date.split('/');
                if (dateSplit[2] && dateSplit[1]) {
                    formattedDate = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`
                    return formattedDate;
                }
            }
            return date;
        },

        clearFilter() {
            this.$router.replace({query: null});
            window.location.reload();
        },

        setFilter() {
            this.filter = {
                'guestName': this.filterGuestName ?? '',
                'createdStartDate': this.formatDateToFilter(this.filterCreatedStartDate) ?? '',
                'createdUntilDate': this.formatDateToFilter(this.filterCreatedUntilDate) ?? '',
            }
            this.filteredResult = this.resultIsFiltered(this.filter);
            this.$refs.guestReportTable.setFilter(this.filter);
        },

        applyFilter() {
            this.setFilter();
            this.$refs.guestReportTable.getReportData(this.filter);
            this.filterDrawer = !this.filterDrawer;
        },

        resultIsFiltered(filter) {
            for (let filterKey in filter) {
                if (filter[filterKey]) {
                    return true;
                }
            }
            return false;
        },

        getFilterFromUrlQuery() {
            if(Object.keys(this.$route.query).length) {
                const {
                    guestName,
                    createdStartDate,
                    createdUntilDate,
                    startDate,
                    finalDate,
                } = this.$route.query;
                if (guestName) {
                    this.filterGuestName = guestName;
                }
                if (createdStartDate || startDate) {
                    this.filterCreatedStartDate = createdStartDate ?? startDate;
                }
                if (createdUntilDate || finalDate) {
                    this.filterCreatedUntilDate = createdUntilDate ?? finalDate;
                }
            }
            this.setFilter();
        },

        async exportReport () {
            try {
                this.awaitingReportDownload = true;
                const response = await axios.get('/api/reports/guest/export', { params: this.getQueryParams(), responseType: 'blob' });
                downloadFile(response.data, getFileNameWithSalt('relatorio_hospedes_partner_hub'), 'xls');
            } catch (error) {
                this.$simpleDialog('Ocorreu um erro ao baixar o relatório!', 'error');
            } finally {
                this.awaitingReportDownload = false;
            }
        },

        getQueryParams () {
            return {
                sortBy: this.getParamFromQuery('sortBy'),
                sortDesc: this.getParamFromQuery('sortDesc'),
                limit: this.getParamFromQuery('limit'),
                guestName: this.filter.guestName,
                createdStartDate: this.filter.createdStartDate,
                createdUntilDate: this.filter.createdUntilDate,
            }
        },

        getParamFromQuery (paramName) {
            const param =  this.$route.query[paramName];
            return Array.isArray(param) ? param[0] : param;
        }
    },

    mounted() {
        this.getFilterFromUrlQuery();
    },

    watch: {
        createdStartDateCalendar: function(date) {
            this.filterCreatedStartDate = this.formatDate(date);
        },
        createdUntilDateCalendar: function(date) {
            this.filterCreatedUntilDate = this.formatDate(date);
        },
    },
}
</script>

<style scoped>
.report-body {
    background: #f0f0f0;
    max-width: 100%;
    min-height: 100vh;
}

.filter-btn {
    color: #FFF;
}

.filter-label {
    font-size: 18px;
    color: #333;
}
</style>
